export const BASE_CREATE_TRY = 'BASE_CREATE_TRY';
export const BASE_CREATE_OK = 'BASE_CREATE_OK';
export const BASE_CREATE_ERROR = 'BASE_CREATE_ERROR';